










import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { TABLE_DATA } from '@/main/store/listEditTypes';
import { Povzaloha } from '@/modules/ojeteVozy/zalohy';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { store } from '../store/edit';
import { ZALOHA_POV } from '../constants';

export default EditStoreMixin.extend({
	name: 'ZalohaPovList',
	data() {
		return {
			ZALOHA_POV,
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
	methods: {
		async refreshTable() {
			await this.$store.dispatch(`${this.storeUri}/${ZALOHA_POV}_${TABLE_DATA}`, { filter: { PovId: this.PovId } });
		},
		openZalohaEdit(event: any) {
			openEdit(Povzaloha.name, PageMode.EDIT, {
				props: true,
				id: event.data.ID,
				filter: {
					PovNr: event.data.POVZALOHA_NR,
					ZakaznikIdText: this.ZakaznikIdText,
					VozidloText: this.Vozidlo,
				},
			});
		},
		openZalohaView(event: any) {
			openEdit(Povzaloha.name, PageMode.VIEW, {
				props: true,
				id: event.data.ID,
				filter: {
					PovNr: event.data.POVZALOHA_NR,
					ZakaznikIdText: this.ZakaznikIdText,
					VozidloText: this.Vozidlo,
				},
			});
		},
	},
});
